import { Editor } from "@tinymce/tinymce-react";
import { useRef, useState } from "react";
import { Loader2 } from "lucide-react";

interface TinyMCEEditorProps {
  value: string;
  onChange: (html: string) => void;
  disabled?: boolean;
}

const TinyMCEEditor = ({
  value,
  onChange,
  disabled = false,
}: TinyMCEEditorProps) => {
  const editorRef = useRef<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleEditorChange = (content: string) => {
    onChange(content);
  };

  const handleEditorInit = (evt: any, editor: any) => {
    editorRef.current = editor;
    setIsLoading(false);
  };

  return (
    <div className="border border-gray-300 rounded-md overflow-hidden relative">
      {isLoading && (
        <div className="absolute inset-0 bg-white bg-opacity-90 flex items-center justify-center z-10">
          <div className="flex items-center space-x-2">
            <Loader2 className="h-6 w-6 animate-spin text-blue-600" />
            <span className="text-sm text-gray-600">Loading editor...</span>
          </div>
        </div>
      )}
      <Editor
        apiKey="7g6zukpk6fqjgp65jr4v5pekqoeiw58kxtkeryh1v4yjhrkx"
        onInit={handleEditorInit}
        value={value}
        onEditorChange={handleEditorChange}
        disabled={disabled}
        init={{
          height: 500,
          menubar: true,
          // Preserve Liquid template syntax
          entity_encoding: "raw",
          entities: "",
          convert_urls: false,
          preserve_cdata: true,
          verify_html: false,
          encoding: "raw",
          // Don't encode special characters
          cleanup: false,
          // Prevent forced encoding of specific characters
          schema: "html5",
          force_p_newlines: false,
          forced_root_block: "",
          // More explicit entity settings
          remove_script_host: false,
          relative_urls: false,
          // Content filtering settings
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "help",
            "wordcount",
            "emoticons",
            "template",
            "paste",
            "textpattern",
            "noneditable",
            "quickbars",
            "pagebreak",
            "save",
            "directionality",
          ],
          toolbar: [
            "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | " +
              "forecolor backcolor | alignleft aligncenter alignright alignjustify | " +
              "bullist numlist outdent indent | removeformat | help",
            "link image media table | code fullscreen preview | " +
              "searchreplace visualblocks | insertdatetime pagebreak | emoticons template",
          ],
          // Setup function to prevent entity encoding
          setup: function (editor: any) {
            // Override the default entity encoding
            editor.on("GetContent", function (e: any) {
              // Replace encoded entities back to original characters
              e.content = e.content.replace(/&gt;/g, ">");
              e.content = e.content.replace(/&lt;/g, "<");
              e.content = e.content.replace(/&amp;/g, "&");
            });
          },
        }}
      />
    </div>
  );
};

export default TinyMCEEditor;
